<script lang="ts">
	import { sponsoredSheet } from '$components/home/SheetData.js';

	export let achievementId: string;

</script>

<div class="sponsored-tag-content" data-testid="achievement-sponsored-tag">
	<div class="oc-copy-75">
		<oc-link-v2 as-button="" size="75" variant="secondary"
			data-oc-sheet-v1-create={JSON.stringify(sponsoredSheet(achievementId))}
		>gesponsert
		</oc-link-v2>
	</div>
	<oc-icon-v1 data-testid="sponsored-icon" type="info-hint" size="50" aria-hidden="true"></oc-icon-v1>
</div>


<style lang="scss">

  .sponsored-tag-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 1.5rem;
		gap: 4px;
  }
</style>
